function updatePost() {

    _edit.on('submit', function(e) {
        e.preventDefault();
    }).validate({
        messages: {
            gender: _gendertext
        },
        submitHandler: function(form) {
            edit(form);
        }

    });

}

function editLoad(data) {

    var status = data.status;

    if (status != 'active') {

       //showResult(_emailverifydashboard, 'warning');

   }

}


function homeeventChangeForm(passport) {

    homeEvents();

    var user = passport;

    $('#home-event-change form').on('submit', function(e) {
        e.preventDefault();
    }).validate({
        submitHandler: function(form) {

            $('#home-event-change form button[type="submit"]').addClass('working disabled');
            var formdata = $('#home-event-change form').serialize();
            $('#home-event-change-form-response').html('');

            $.ajax({
                url: ultra_settings.ajax_url,
                data: formdata,
                type: 'post',
                success: function(data){

                    if ( data.valid != false) {
                        var successtext = '<p>Thank you for submitting your request to change your home event. You will be notified if your request is approved.</p>';
                        $('#home-event-change-form-response').html(successtext);
                        $('#home-event-change form').slideUp(500, 'easeInOutExpo');
                        $('#home-event-change-form-response').slideDown(500, 'easeInOutExpo');
                    } else {
                        var successtext = '<p>Oops, something went wrong, please notify support.</p>';
                        $('#home-event-change-response').html(successtext);
                        //$('#home-event-change form').slideUp(500, 'easeInOutExpo');
                        //$('#home-event-change-form-response').slideDown(500, 'easeInOutExpo');
                    }
                }
            });
        }
    });


}

function accountDeleteForm(passport) {

    var user = passport;

    $('#delete-my-account form').on('submit', function(e) {
        e.preventDefault();
    }).validate({
        submitHandler: function(form) {

            $('#delete-my-account form button[type="submit"]').addClass('working disabled');
            var formdata = $('#delete-my-account form').serialize();
            $('#delete-my-account-form-response').html('');

            $.ajax({
                url: ultra_settings.ajax_url,
                data: formdata,
                type: 'post',
                success: function(data){
                    var successtext = '<p>Your request for account deletion has been submitted. Thank you.</p>';
                    $('#delete-my-account-form-response').html(successtext);
                    $('#delete-my-account form').slideUp(500, 'easeInOutExpo');
                    $('#delete-my-account-form-response').slideDown(500, 'easeInOutExpo');
                }
            });
        }
    });

    return;

    $('a.delete-account').trigger('click');
    $('#delete-my-account form input[name="reason"]').val('test');
    $('#delete-my-account form input[name="terms"]').prop('checked', 'checked');

}



function processChangeEmailForm() {

    _changeemail.on('submit', function(e) {
        e.preventDefault();
    }).validate({
        submitHandler: function(form) {
            processChangeEmail(form);
        }
    });

}

function processChangeEmail() {

    var email = $('#email').val();
    var token = $('#token').val();
    var locale = $('#locale').val();

    return passport.processChangeEmail(token,email, upp_page.events, locale)

    .fail(function(jqXHR, textStatus, error){
        $(document).trigger('rebuild');
        if (jqXHR.status == 401) {
          //$(document).trigger('logged-out');
          showResult(errors.token, 'error');
      } else if (jqXHR.status == 409) {
          showResult(errors.duplicateemail, 'error');
      } else if (jqXHR.status == 404) {
          showResult(errors.token, 'error');
      } else {
          showResult(errors.token, 'error');
      }
  })
    .done(function(data, textStatus, jqXHR){
        showResult(_emailupdatedverified, 'success');
        $(document).trigger('rebuild');

        setTimeout(function() {
            document.location = upp_page.dashboard;
        }, 2000);

    })
}


function edit() {

    var actoken = getUrlParam('token');
    var locale = $('#locale').val();

    var _birthday = `${$('#birthyear').val()}-${$('#birthmonth').val()}-${$('#birthday').val()}`;

    var formdata = {
        firstname: $('#firstname').val(),
        lastname: $('#lastname').val(),
        email: $('#email').val(),
        birthday: _birthday,
        gender: $('input[name="gender"]:checked').val(),
        country: $('#country').val()
    };

    var activateurl = upp_page.verify+'?token='+actoken+'&email='+formdata.email;

    var passreset = $('#password').val();
    var allowreset = false;

    if(passreset) {

        if ( passreset.length >= 8 ) {

            allowreset = true;

        } else {

            showResult(errors.password, 'error');
            return false;
        }

    }

    if(allowreset) {

        var formdata = {
            firstname: $('#firstname').val(),
            lastname: $('#lastname').val(),
            email: $('#email').val(),
            password: $('#password').val(),
            birthday: _birthday,
            gender: $('input[name="gender"]:checked').val(),
            country: $('#country').val(),
        };

    }

    passport.update(formdata, upp_page.change_email, locale)
    .fail(function(jqXHR, textStatus, error){
        $(document).trigger('rebuild');

        if (jqXHR.status == 400) {
            var responseJSON = jqXHR.responseJSON;

            if(responseJSON.errors)  {

                if (responseJSON.errors.birthday) {
                    log('birthday error');
                    showResult(errors.birthday, 'error');
                    $('#birthmonth').addClass('error');
                    $('#birthday').addClass('error');
                    $('#birthyear').addClass('error');
                }

                if (responseJSON.errors.password) {
                    log('pw error');
                    showResult(errors.password, 'error');
                    $('#password').addClass('error');
                }
            }
        } else
        if (jqXHR.status == 401) {
            $(document).trigger('logged-out');
        } else
        if (jqXHR.status == 0) {
            showResult(_revalidate, 'warning');
        } else
        if (jqXHR.status == 409) {
            showResult(errors.duplicateemail, 'error');
        } else {
            showResult(errors.general, 'error');
        }

    })
    .done(function(formdata, textStatus, jqXHR){

         //log(jqXHR);


         if( $('#edit-form').hasClass('nc')) {

             if(actoken) {
                 log(activateurl);
                 document.location = activateurl;
             } else {
                 sendVerify(upp_page.verify);
                 $('#edit-form').removeClass('nc');
                 showResult(_verifysent, 'success');
                 return;
             }

         }


         if (_edit.hasClass('changed')) {
             _edit.removeClass('changed');
            //$('#password').val('');

            if (jqXHR.status == 200) {
                showResult(_accountupdated, 'success');
            }

            if (jqXHR.status == 202) {
                showResult(_emailupdatedstarted, 'warning');
            }



        } else {
            showResult(_nochanges, 'info');
        }

        if(allowreset) {

            uppLogin(formdata.email, passreset).done(function () {
              //document.location.href = upp_page.dashboard;
              $(document).trigger('rebuild');
              $('#password').val('');
          });

        } else {
            $(document).trigger('rebuild');
        }

    })

}


function completeForms(data) {

    var nb = 0;
    var ng = 0;

    $('input[data-field], select[data-field]').each(function(){

        var el = $(this);
        var field = el.attr('data-field');
        var val = data[field];

        if(field == 'birthday') {
            if(val) {
                var year = val.slice(0, 4);
                var month = val.slice(5, 7);
                var day = val.slice(8, 10);

                $('#birthmonth').val(month);
                $('#birthyear').val(year);
                $('#birthday').val(day);
            } else {
                nb = 1;
            }

            return;
        }


        if(field == 'homeevent') {

        getEventJSON()
        .done(function(data) {
            $.each( data, function( key, v ) {

                if ( !v.web ) {
                    return;
                }

                if(val == v.passport.subscription_code) {
                    el.val(`${v.type} ${v.title}`);
                }

            });
        });

        return;
    }

    if ( $(this).attr('type') == 'radio' ) {

        if (val == 'female') {
            $('input.female').prop('checked', true);
        }
        if (val == 'male') {
            $('input.male').prop('checked', true);
        }
        if (!val) {
            ng = 1;
        }

    } else {

        el.val(val);

    }

});

  // if dob or gender not completed
  if(ng || nb) {
      showResult(errors.pnc, 'warning');
      $('#edit-form').addClass('nc');
      if(nb) {
          $('.datefield .subfield>select').addClass('error');
      }
      if(ng) {
          $('li.gender>ul>li>label:first').prepend('<label id="gender-error" class="error" for="gender">You must choose a gender.</label>');
      }
  }

}


